// ブラウザの現地時刻（日本なら日本時間）で YYYY-MM-DD を返す
// ※ toISOString() は UTC のため、日本時間の 0〜9時は前日の日付になってしまう
export const getLocalDateString = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
